// Module
var code = "<category name=\"Compass\" colour=\"#A016E5\" iconclass=\"blocklyTreeIconCustom compass\"> <label text=\"Compass\" web-class=\"myLabelStyle\"></label> <block type=\"compasscalibrate\"></block> <block type=\"compasscalibrated\"></block> </category>";
// Exports
export default code;